import React from "react";
import { PageHeader, Container } from "@/components/PageShell";
import { useAuth } from "@/lib/auth";

export default function Settings() {
    const { admin } = useAuth();

    return (
        <>
            <PageHeader title="Настройки" subtitle="Профиль администратора" testid="settings-header" />
            <Container>
                <div className="max-w-2xl space-y-6">
                    <div className="bg-white border border-zinc-200 rounded-md p-5">
                        <h2 className="text-sm font-semibold mb-3">Профиль</h2>
                        <div className="grid grid-cols-[120px_1fr] gap-3 text-sm">
                            <div className="text-zinc-500 text-xs uppercase tracking-wider mt-1">Email</div>
                            <div className="font-mono">{admin?.email}</div>
                            <div className="text-zinc-500 text-xs uppercase tracking-wider mt-1">Роль</div>
                            <div className="font-mono">{admin?.role}</div>
                            <div className="text-zinc-500 text-xs uppercase tracking-wider mt-1">ID</div>
                            <div className="font-mono text-xs text-zinc-600 break-all">{admin?.id}</div>
                        </div>
                        <div className="mt-4 text-xs text-zinc-500">
                            Учётные данные заданы в переменных окружения backend. При их изменении перезапустите backend — пароль будет перехеширован автоматически.
                        </div>
                    </div>

                    <div className="bg-white border border-zinc-200 rounded-md p-5">
                        <h2 className="text-sm font-semibold mb-3">Сессия</h2>
                        <div className="text-xs text-zinc-600">
                            Авторизация выполняется по JWT-токену, который хранится локально в браузере.
                            Срок действия токена — 24 часа. После истечения будет запрошен повторный вход.
                        </div>
                    </div>
                </div>
            </Container>
        </>
    );
}
